import ring1 from "../audio/ring1.mp3";
import ring2 from "../audio/ring2.mp3";
import ring3 from "../audio/ring3.mp3";
import ring4 from "../audio/ring4.mp3";
import ring5 from "../audio/ring5.mp3";

export default text => {
  return [
    {
      text: text("settings.smartphone"),
      value: "SMARTPHONE",
      audio: ring1,
    },
    {
      text: text("settings.bell"),
      value: "BELL",
      audio: ring2,
    },
    {
      text: text("settings.marimba"),
      value: "MARIMBA",
      audio: ring3,
    },
    {
      text: text("settings.classic"),
      value: "CLASSIC",
      audio: ring4,
    },
    {
      text: text("settings.glas"),
      value: "GLAS",
      audio: ring5,
    },
  ];
};






// WEBPACK FOOTER //
// ./src/branding/default/js/ringsignals.js